import { render, staticRenderFns } from "./VMultiselectAutocomplete.vue?vue&type=template&id=c137f5ae&"
import script from "./VMultiselectAutocomplete.vue?vue&type=script&lang=js&"
export * from "./VMultiselectAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports